import { RouteView, PageView } from '../layouts'

export const operation = {
  path: '/operation',
  name: 'BaseForm',
  component: PageView,
  meta: { title: '运营管理', icon: 'deployment-unit', isMenuShow: true, permission: 'opt' },
  children: [
    {
      path: '/operation/message',
      name: 'BaseForm',
      component: PageView,
      redirect: '/operation/message/list',
      meta: { title: '消息管理', icon: 'dollar', isMenuShow: true, permission: 'opt:msg' },
      children: [
        {
          path: '/operation/message/list',
          name: 'BaseForm',
          component: () => import('../views/operation/msgList.vue'),
          meta: { title: '消息管理', icon: 'dollar', isMenuShow: true, permission: 'opt:msg' },
        },
        {
          path: '/operation/message/detail',
          name: 'BaseForm',
          component: () => import('../views/operation/sendDetail.vue'),
          meta: { title: '发送明细', icon: 'dollar', isMenuShow: true, permission: 'opt:msg:detail' },
        }
      ]

    },
    {
      path: '/operation/user',
      name: 'BaseForm',
      component: PageView,
      redirect: '/operation/user/index',
      meta: { title: '用户关怀', icon: 'dollar', isMenuShow: true, permission: 'opt:msg' },
      children: [
        {
          path: '/operation/user/index',
          name: 'BaseForm',
          component: () => import('../views/operation/user/index.vue'),
          meta: { title: '用户关怀', icon: 'dollar', isMenuShow: true, permission: 'opt:msg' },
        },
        {
          path: '/operation/user/detail',
          name: 'BaseForm',
          component: () => import('../views/operation/user/detail.vue'),
          meta: { title: '发送详情', icon: 'dollar', isMenuShow: true, permission: 'opt:msg:detail' },
        }
      ]

    },
    {
      path: '/operation/modal',
      name: 'BaseForm',
      component: PageView,
      redirect: '/operation/modalManage',
      meta: { title: '协议弹窗管理', icon: 'dollar', isMenuShow: true, permission: 'opt:pop' },
      children: [
        {
          path: '/operation/modalManage',
          name: 'BaseForm',
          component: () => import('../views/operation/modalManage.vue'),
          meta: { title: '协议弹窗管理', icon: 'dollar', isMenuShow: true, permission: 'opt:pop' },
        },
        {
          path: '/operation/message/add',
          name: 'BaseForm',
          component: () => import('../views/operation/addModal.vue'),
          meta: { title: '添加弹窗', icon: 'dollar', isMenuShow: true, permission: 'opt:pop:edit' },
        }
      ]

    },
    {
      path: '/operation/activeManagement',
      redirect: '/operation/activity/list',
      name: 'integral',
      component: () => import('../views/operation/activeManagement.vue'),
      meta: { title: '活动管理', icon: 'skin', isMenuShow: true, permission: 'opt:act' },
      children: [
        {
          path: '/operation/activity/list',
          name: '',
          component: () => import('../views/operation/activityList.vue'),
          meta: { title: '活动列表', icon: 'dollar', isMenuShow: true, permission: 'opt:act' },
        },
        {
          path: '/operation/activity/offlineDetail',
          name: 'BaseForm',
          component: () => import('../views/operation/offlineActivityDetails.vue'),
          meta: { title: '线下活动明细', keepAlive: false, isMenuShow: false, permission: 'opt:act:detail' }
        },
        {
          path: '/operation/activity/onlineDetail',
          name: 'BaseForm',
          component: () => import('../views/operation/onlineActivityDetail.vue'),
          meta: { title: '线上活动明细', keepAlive: false, isMenuShow: false, permission: 'opt:act:detail' }
        },
        {
          path: '/operation/activity/info',
          name: 'BaseForm',
          component: () => import('../views/operation/activityInfo.vue'),
          meta: { title: '活动详情', keepAlive: false, isMenuShow: false, permission: 'opt:act:detail' }
        },
        {
          path: '/operation/activity/activityUpdate',
          name: 'BaseForm',
          component: () => import('../views/operation/activityUpdate.vue'),
          meta: { title: '活动编辑', keepAlive: false, isMenuShow: false, permission: 'opt:act:edit' }
        },
        {
          path: '/operation/activity/activityCreate',
          name: 'BaseForm',
          component: () => import('../views/operation/activityCreate.vue'),
          meta: { title: '活动新增', keepAlive: false, isMenuShow: true, permission: 'opt:act:add' },
        },
        {
          path: '/operation/activity/activityType',
          name: 'BaseForm',
          component: () => import('../views/operation/activityType.vue'),
          meta: { title: '活动种类列表', keepAlive: false, isMenuShow: true, permission: 'opt:act:add' },
        },
      ]
    },
    // {
    //     path: '/operation/activity',
    //     name: 'BaseForm',
    //     component: PageView,
    //     redirect: '/operation/activity/list',
    //     meta: {title: '活动管理', icon: 'dollar', isMenuShow: true, permission: 'opt:act'},
    //     children: [
    //         {
    //             path: '/operation/activity/list',
    //             name: '',
    //             component: () => import('../views/operation/activityList.vue'),
    //             meta: {title: '活动列表', icon: 'dollar', isMenuShow: true, permission: 'opt:act'},
    //         },
    //         {
    //             path: '/operation/activity/offlineDetail',
    //             name: 'BaseForm',
    //             component: () => import('../views/operation/offlineActivityDetails.vue'),
    //             meta: {title: '线下活动明细', keepAlive: false, isMenuShow: false, permission: 'opt:act:detail'}
    //         },
    //         {
    //             path: '/operation/activity/onlineDetail',
    //             name: 'BaseForm',
    //             component: () => import('../views/operation/onlineActivityDetail.vue'),
    //             meta: {title: '线上活动明细', keepAlive: false, isMenuShow: false, permission: 'opt:act:detail'}
    //         },
    //         {
    //             path: '/operation/activity/info',
    //             name: 'BaseForm',
    //             component: () => import('../views/operation/activityInfo.vue'),
    //             meta: {title: '活动详情', keepAlive: false, isMenuShow: false, permission: 'opt:act:detail'}
    //         },
    //         {
    //             path: '/operation/activity/activityUpdate',
    //             name: 'BaseForm',
    //             component: () => import('../views/operation/activityUpdate.vue'),
    //             meta: {title: '活动编辑', keepAlive: false, isMenuShow: false, permission: 'opt:act:edit'}
    //         },
    //         {
    //             path: '/operation/activity/activityCreate',
    //             name: 'BaseForm',
    //             component: () => import('../views/operation/activityCreate.vue'),
    //             meta: {title: '活动新增', keepAlive: false, isMenuShow: true, permission: 'opt:act:add'},
    //         },
    //     ],
    // },
    // 删除
    // {
    //     path: '/operation/advertisement',
    //     name: 'BaseForm',
    //     // redirect:'/operation/activity/list',
    //     component: () => import('../views/operation/advetrisement.vue'),
    //     meta: {title: '广告管理', icon: 'dollar', isMenuShow: true, permission: 'opt:adv'},
    // },
    {
      path: '/zoneManager',
      name: 'BaseForm',
      component: PageView,
      redirect: '/zoneManager',
      meta: { title: '专区管理', keepAlive: false, isMenuShow: true, permission: 'opt:zoneManager' },
      children: [
        {
          path: '/zoneManager',
          name: 'BaseForm',
          component: () => import('@/views/zone'),
          meta: { title: '专区管理', keepAlive: false, isMenuShow: true, permission: 'opt:zoneManager' },
        },
        {
          path: '/zone',
          name: 'BaseForm',
          component: () => import('@/views/zone/zone'),
          meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'opt:zoneManager' },
        },
      ]
    },
    {
      path: '/affiche',
      name: 'BaseForm',
      component: PageView,
      redirect: '/affiche',
      meta: { title: '公告管理', keepAlive: false, isMenuShow: true, permission: 'opt:adv' },
      children: [
        {
          path: '/affiche',
          name: 'BaseForm',
          component: () => import('@/views/affiche'),
          meta: { title: '', keepAlive: false, isMenuShow: true, permission: 'mall:adv' },
        },
        {
          path: '/afficheMsg',
          name: 'BaseForm',
          component: () => import('@/views/affiche/editorAffiche'),
          meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'mall:adv' },
        },
        {
          path: '/afficheInfo',
          name: 'BaseForm',
          component: () => import('@/views/affiche/editorInfo'),
          meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'mall:adv' },
        }
      ]
    },
    {
      path: '/mall/imageCarousel',
      name: 'BaseForm',
      component: PageView,
      redirect: '/mall/imageCarousel/list',
      meta: { title: '广告管理', keepAlive: false, isMenuShow: true, permission: 'opt:adv' },
      children: [
        {
          path: '/mall/imageCarousel/list',
          name: 'BaseForm',
          component: () => import('../views/mall/imageCarouselList.vue'),
          meta: { title: '广告列表', keepAlive: false, isMenuShow: true, permission: 'mall:adv' },
        },
        {
          path: '/mall/imageCarousel/detail',
          name: 'BaseForm',
          component: () => import('../views/mall/imageCarouselDetail.vue'),
          meta: { title: '广告编辑', keepAlive: false, isMenuShow: false, permission: 'mall:adv:edit' }
        },
        {
          path: '/mall/imageCarousel/addImageCarousel',
          name: 'BaseForm',
          component: () => import('../views/mall/addImageCarousel.vue'),
          meta: { title: '添加广告', keepAlive: false, isMenuShow: false, permission: 'mall:adv:add' }
        },
        // {
        //     path: '/mall/imageCarousel/update',
        //     name: 'BaseForm',
        //     component: () => import('@/views/mall/updateImageCarousel.vue'),
        //     meta: { title: '编辑广告', keepAlive: false, isMenuShow:false}
        // },
      ]
    },
    {
      path: '/operation/keyWord',
      name: 'BaseForm',
      // component: PageView,
      // redirect:'/operation/message/list',
      component: () => import('../views/operation/keywordList.vue'),
      meta: { title: '热搜管理', icon: 'dollar', keepAlive: false, isMenuShow: true, permission: 'opt:hot' },
    },
    {
      path: '/operation/hotSearch',
      name: 'BaseForm',
      component: () => import('../views/operation/hotSearchList.vue'),
      meta: { title: '热搜管理', keepAlive: false, isMenuShow: false, permission: 'opt:hot' },
    },
    // 删除
    {
      path: '/operation/adLanding',
      name: 'adLanding',
      meta: { title: '广告页管理', keepAlive: false, isMenuShow: true, permission: 'opt' },
      component: PageView,
      redirect: '/operation/adLanding/list',
      children: [
        {
          path: '/operation/adLanding/list',
          name: 'adLandingList',
          component: () => import('../views/operation/adLandingList.vue'),
          meta: { title: '', keepAlive: false, isMenuShow: true, permission: 'opt:adv' },//opt:adv
        },
        {
          path: '/operation/adLanding/edit',
          name: 'adLandingEdit',
          component: () => import('../views/operation/adLandingEdit.vue'),
          meta: { title: '', keepAlive: false, isMenuShow: false, permission: 'opt:adv' },//opt:adv
        },
      ]
    },
    {
      path: '/operation/address',
      name: 'address',
      component: PageView,
      meta: { title: '下载渠道管理', icon: 'crown', isMenuShow: true, permission: 'opt:channel' },
      redirect: '/operation/address',
      children: [
        {
          path: '/operation/address',
          name: 'address',
          component: () => import('../views/operation/address.vue'),
          meta: { title: '下载渠道管理', keepAlive: false, isMenuShow: true, permission: 'opt:channel' },
        }
      ]
    },
    {
      path: '/operation/bulletManagement',
      redirect: '/operation/bullet/list',
      name: 'integral',
      component: PageView,
      meta: { title: '弹框管理', icon: 'skin', isMenuShow: true, permission: 'opt:popup:list' },
      children: [
        {
          path: '/operation/bullet/list',
          name: 'bulletList',
          component: () => import('../views/operation/bullet/list.vue'),
          meta: { title: '弹框列表', icon: 'dollar', isMenuShow: true, permission: 'opt:popup:list' },
        },
        {
          path: '/operation/bullet/add',
          name: 'bulletListAdd',
          component: () => import('../views/operation/bullet/addandEdit.vue'),
          meta: { title: '弹框新增', keepAlive: false, isMenuShow: true, permission: 'opt:popup:add' },
        },
        {
          path: '/operation/bullet/edit',
          name: 'bulletListEdit',
          component: () => import('../views/operation/bullet/addandEdit.vue'),
          meta: { title: '弹框编辑', keepAlive: false, isMenuShow: true, permission: 'opt:popup:edit' },
        },
      ]
    },
    {
      path: '/operation/jclue/detail',//京友会
      name: 'detail',
      component: () => import('../views/operation/jclue/detail.vue'),
      meta: { title: '京友会', isMenuShow: true, permission: 'opt:jclue' },
    },
    {
      path: '/operation/wechat/weChatGiftList',
      name: 'BaseForm',
      component: () => import('../views/operation/weChat/weChatGiftList'),
      meta: { title: '推荐赢好礼', icon: 'dollar', isMenuShow: true, permission: 'opt:recommendGift' },
    },
    {
      path: '/operation/wechat/weChatGiftEnrollList',
      name: 'BaseForm',
      component: () => import('../views/operation/weChat/weChatGiftEnrollList'),
      meta: { title: '推荐赢好礼报名列表', icon: 'dollar', isMenuShow: true, permission: 'opt:recommendGift' },
    },
    {
      path: '/operation/wechat/wechatSetRule',
      name: 'BaseForm',
      component: () => import('../views/operation/weChat/wechatSetRule'),
      meta: { title: '配置规则', icon: 'dollar', isMenuShow: false, permission: 'opt:recommendGift' },
    },
    {
      path: '/operation/wechat/reclist',
      name: 'BaseForm',
      component: () => import('../views/operation/weChat/wechatrecommendList'),
      meta: { title: '参与人员', icon: 'dollar', isMenuShow: false, permission: 'opt:recommendGift' },
    },
    {
      path: '/operation/wechat/actlist',
      name: 'BaseForm',
      component: () => import('../views/operation/weChat/wechatActivitylist'),
      meta: { title: '活动排名', icon: 'dollar', isMenuShow: false, permission: 'opt:recommendGift' },
    },
    {
      path: '/operation/wechat/wechatProvideList',
      name: 'BaseForm',
      component: () => import('../views/operation/weChat/wechatProvideList'),
      meta: { title: '发放记录', icon: 'dollar', isMenuShow: false, permission: 'opt:recommendGift' },
    },
    // {
    //   path: '/operation/yiQingDistrict',
    //   name: 'BaseForm',
    //   component: () => import('../views/operation/yiQingDistrict'),
    //   meta: { title: '魔方专区', icon: 'dollar', isMenuShow: true, permission: 'opt:yiQingDistrict' },
    // },
  ]
}
